(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collapsible-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    let buttonTabs = document.querySelectorAll('.tab-button-item');
    buttonTabs.forEach(button => {
      button.addEventListener('click', function(){
        buttonTabs.forEach(element =>{
          element.classList.remove('active')
        })
        button.classList.add('active');
        let buttonDataTab = button.getAttribute('data-tab');
        let tabWrappers =  document.querySelectorAll('.collapsible-tab_wrapper');
        tabWrappers.forEach(tab => {
          tab.classList.remove('active');
          let tabWrapperTab = tab.getAttribute('data-tab');
          if(tabWrapperTab == buttonDataTab){
            tab.classList.add('active')
          }
        })
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let filterToggle = document.querySelector('.don-facet-drawer-button');
  let drawerFilter = document.querySelector('.don-filter')
  if(filterToggle){
    filterToggle.addEventListener('click', function(){
      drawerFilter.classList.add('active');
    })
  }
  let closeButtonFilter = document.querySelector('.close-drawer-don-filter');
  if(closeButtonFilter){ 
  closeButtonFilter.addEventListener('click', function(){
    drawerFilter.classList.remove('active')
  })
  }
  const filterButtons = document.querySelectorAll('.filter_button');

  // Sync with URL params on load
  const urlParams = new URLSearchParams(window.location.search);
  const tagParam = urlParams.get('filter.p.tag');

  if (tagParam) {
    filterButtons.forEach(button => {
      const attribute = button.getAttribute('data-filter');
      if (attribute === tagParam) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }

  // Handle button clicks
  filterButtons.forEach(button => {
    button.addEventListener('click', function () {
      drawerFilter.classList.remove('active');
      const attributeButton = button.getAttribute('data-filter');

      // If clicking the already active button, do nothing
      if (button.classList.contains('active') && attributeButton !== 'all') return;

      filterButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      // Find the facet form to use
      const facetForm = document.querySelector('form[is="facet-form"]');
      if (!facetForm) return;

      // Remove any existing tag filters
      const existingTagFilters = document.querySelectorAll('[name^="filter.p.tag"]');
      existingTagFilters.forEach(filter => {
        if (filter.closest('form[is="facet-form"]')) {
          filter.remove();
        }
      });

      // If attribute is not 'all', add the new filter
      if (attributeButton !== 'all') {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'filter.p.tag';
        hiddenInput.value = attributeButton;
        facetForm.appendChild(hiddenInput);
      }

      // Trigger the form change
      facetForm.dispatchEvent(new Event('change', { bubbles: true }));

      // If 'all' was clicked, also update URL to remove the filter param
      if (attributeButton === 'all') {
        const url = new URL(window.location);
        url.searchParams.delete('filter.p.tag');
        history.pushState({}, '', url);
      }
    });
  });

  // Listen for facet updates to sync our buttons
  const facetUpdateHandler = (event) => {
    const parsedHTML = new DOMParser().parseFromString(event.detail.responseText, 'text/html');
    const activeFilters = parsedHTML.querySelectorAll('[name^="filter.p.tag"]');
    
    const activeTags = Array.from(activeFilters).map(input => input.value);
    
    // If no active tags, activate the 'all' button if it exists
    if (activeTags.length === 0) {
      const allButton = document.querySelector('.filter_button[data-filter="all"]');
      if (allButton) {
        filterButtons.forEach(btn => btn.classList.remove('active'));
        allButton.classList.add('active');
      }
      return;
    }
    
    filterButtons.forEach(button => {
      const attribute = button.getAttribute('data-filter');
      if (activeTags.includes(attribute)) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  };

  document.addEventListener('facet:update', facetUpdateHandler);
});


  } catch(e) { console.error(e); }
})();
})();
